import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
  name: 'ivDisplayFn'
})
export class DisplayFnPipe implements PipeTransform {
  transform(text: any): string {
    if (text) {
      if (text.code && text.name) {
        return `${text.code}: ${text.name}`;
      }
      if (text.label && text.value) {
        return `${text.value}: ${text.label}`;
      }
    }
    return '';
  }
}
